import React, { useState, useEffect } from "react";
import withifulllogo from "../Images/Header/Waitefulllogo.png";
import redfulllogo from "../Images/Header/Redfulllogo.png";
import './CSS/Header.css';


const Header = ({ currentView, onNavigate, onScrollToSection }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigation = (view) => {
    onNavigate(view);
    setIsMenuOpen(false);
  };

  const handleSectionScroll = (sectionId) => {
    onScrollToSection(sectionId);
    setIsMenuOpen(false);
  };

  const handleLogoClick = () => {
    if (currentView !== "home") {
      onNavigate("home");
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <div className="container">
        <div className="header-content">
          <div
            className="logo"
            onClick={handleLogoClick}
            style={{ cursor: "pointer" }}
          >
            <img
              src={isScrolled ? redfulllogo : withifulllogo}
              alt="Ali Darbar"
              className="logo-image"
              width="auto"
              height="50px"
            />
          </div>

          <nav className={`nav ${isMenuOpen ? "nav-open" : ""}`}>
            <ul>
              <li>
                <a
                  href="#home"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation("home");
                  }}
                  className={currentView === "home" ? "active" : ""}
                >
                  Home
                </a>
              </li>

              <li>
                <a
                  href="#about"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation("about");
                  }}
                  className={currentView === "about" ? "active" : ""}
                >
                  About Us
                </a>
              </li>

              {currentView === "home" && (
                <>
                  <li>
                    <a
                      href="#menu"
                      onClick={(e) => {
                        e.preventDefault();
                        handleSectionScroll("menu");
                      }}
                    >
                      Menu
                    </a>
                  </li>
                  <li>
                    <a
                      href="#contact"
                      onClick={(e) => {
                        e.preventDefault();
                        handleSectionScroll("contact");
                      }}
                    >
                      Contact
                    </a>
                  </li>
                </>
              )}
            </ul> {/* ✅ This closing tag was missing */}

            {/* Mobile CTA Button */}
            <div className="nav-mobile-cta">
              <button
                className="btn btn-primary"
                onClick={() => handleNavigation("fullmenu")}
              >
                View Full Menu
              </button>
            </div>
          </nav>

          {/* Desktop CTA Button */}
          <div className="nav-desktop-cta">
            <button
              className="btn btn-primary"
              onClick={() => handleNavigation("fullmenu")}
            >
              View Full Menu
            </button>
          </div>

          <div
            className={`menu-toggle ${isMenuOpen ? "active" : ""}`}
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
